import { Box, HStack, Tooltip, VStack } from "@chakra-ui/react";
import { FallaFP } from "../utils/interfaces";

export default function IssueLog({
  fallasPorDia,
}: {
  fallasPorDia: FallaFP[][];
}): JSX.Element {
  return (
    <VStack>
      <p
        style={{
          fontWeight: "bolder",
          fontSize: "2rem",
          textAlign: "center",
          lineHeight: 1.2,
        }}
      >
        Fallas en el último mes
      </p>
      <HStack width="100%" justifyContent="space-between">
        <p style={{ lineHeight: 1 }}>Hace 30 días</p>
        <p style={{ lineHeight: 1 }}>Hoy</p>
      </HStack>
      <HStack justifyContent="center" gap="2" marginInline="auto">
        {fallasPorDia.slice().reverse().map((fallas, i) => {
          let barColor = "hsl(0, 0%, 80%)";
          let tooltipText = <p>No hubo errores en este día.</p>;
          if (fallas.length > 0) {
            barColor = "hsl(40, 70%, 60%)";
            const tooltipList = [];
            for (let j = 0; j < fallas.length; j++) {
              const falla = fallas[j];
              let textColor = "hsl(40, 75%, 75%)";
              if (falla.es_critica) {
                barColor = "hsl(0, 70%, 60%)";
                textColor = "hsl(0, 75%, 75%)";
              }

              const line = `${falla.tiempo.replace("T", " ").slice(0, 19)} - ${falla.mensaje_falla}`;
              tooltipList.push(
                <p key={`dia${i}-falla${j}`} style={{ color: textColor }}>
                  {line}
                </p>,
              );
            }
            tooltipText = <>{tooltipList}</>;
          }

          return (
            <Tooltip key={i} hasArrow label={tooltipText}>
              <Box
                width="6"
                height="12"
                borderRadius="4"
                backgroundColor={barColor}
              />
            </Tooltip>
          );
        })}
      </HStack>
    </VStack>
  );
}
